import api from '../../utils/services/api';
import { showAlert } from '../ducks/sweetAlert';
import { transactionsActionError, transactionsActionLoading, transactionsActionSuccess } from '../ducks/transactions';
import { userBalanceFetchAction } from './usersActions';
import { transfersFetchAction } from './transfersActions';

export const transactionsFetchAction = (params) => {
  return async (dispatch) => {
    dispatch(transactionsActionLoading());
    try {
      const response = await api.get(
        `/transacoes-dashboard/grafico?DATA_INICIAL=${params.dataMenoSete}&DATA_FINAL=${params.dataHoje}`,
      );
      dispatch(transactionsActionSuccess(response.data));
    } catch (error) {
      dispatch(transactionsActionError(error?.response?.data));
    }
  };
};


export const transactionsRefetchFailedAction = (params) => {
  return async (dispatch) => {
    try {
      const response = await api.post(`/antifraude/analise`, params)
      dispatch(
        showAlert({
          title: response.data?.data?.title || 'Aprovada',
          text: response.data?.mensagem || 'A transação foi aprovada pelo anti-fraude.',
          icon: response?.data?.data?.icon || 'success',
        }),
      );
      dispatch(transfersFetchAction({ PAGE: 1, LIMIT: 10, TIPO: 'Ted' }));
    } catch (error) {
      if (error.response) {
        dispatch(
          showAlert({
            title: error.response.data?.data?.title ||  'Falha',
            text: error.response.data?.mensagem || 'A análise do anti-fraude falhou.',
            icon: error.response.data?.data?.icon || 'error',
          }),
        );
      } else {
        dispatch(
          showAlert({
            title: 'Falha',
            text: 'A análise do anti-fraude falhou.',
            icon: 'error',
          }),
        );
      }
      dispatch(transfersFetchAction({ PAGE: 1, LIMIT: 10, TIPO: 'Ted' }));
    }
  };
};

export const performMakeTransactionAdmin = (params, closeModal) => {
  return async (dispatch) => {
    const closeModals = () => {
      closeModal();
      dispatch(
        userBalanceFetchAction({
          ID_CONTA: params?.ID_CONTA,
          CPFCNPJ_CLIENTE: params?.CPFCNPJ_CLIENTE,
          LIMIT: 10,
          PAGE: 1,
        }),
      );
    };
    dispatch(transactionsActionLoading());
    try {
      const response = await api.post(`/transacao/transferencia-manutencao/adm`, params);
      dispatch(
        showAlert({
          title: 'Sucesso',
          text: response.data?.data?.mensagem || 'Transferência realizada com sucesso',
          icon: 'success',
          func: closeModals,
        }),
      );
      dispatch(transactionsFetchAction({ LIMIT: 10, ORDENACAO: 'DESC', PAGE: 1 }));
    } catch (error) {
      dispatch(transactionsActionError());
      dispatch(
        showAlert({
          title: 'Ops...',
          text: 'Não foi possível realizar a transferência.',
          icon: 'error',
          func: closeModals,
        }),
      );
    }
  };
};

export const performRepaseLote = (params, closeModal) => {
  return async (dispatch) => {
    const closeModals = () => {
      closeModal();
      dispatch(
        userBalanceFetchAction({
          ID_CONTA: params?.ID_CONTA,
          CPFCNPJ_CLIENTE: params?.CPFCNPJ_CLIENTE,
          LIMIT: 10,
          PAGE: 1,
        }),
      );
    };
    dispatch(transactionsActionLoading());
    try {
      const response = await api.post(`/transacao/transferencia-manutencao/adm`, params);
      dispatch(
        showAlert({
          title: 'Sucesso',
          text: response.data?.data?.mensagem || 'Repasse em lote realizado com sucesso',
          icon: 'success',
          func: closeModals,
        }),
      );
    } catch (error) {
      dispatch(transactionsActionError());
      dispatch(
        showAlert({
          title: 'Ops...',
          text: error.response?.data?.mensagem || 'Não foi possível realizar o repasse em lote.',
          icon: 'error',
        }),
      );
    }
  };
};
